import React, { useState } from 'react';
import { LogoUploader } from '../form/logoUploader';
import classNames from 'classnames';
import { JobImageLogoDescription } from '../jobImageLogoDescription/jobImageLogoDescription';
import styles from '../jobForm/jobForm.module.scss';
import buttonStyles from '../jobImageLogoDescription/jobImageLogoDescription.module.scss';
import { ImageUpload } from '../imageUpload/imageUpload';
import { Button } from '../button/button';
import { Badge } from 'reactstrap';

export const JobFormImageBranding = (props) => {
  const { state, setState } = props;
  const [open, setOpen] = useState(true);

  return (
    <>
      <div className={classNames(styles.compCardContainer)}>
        <div
          className={classNames(styles.compCardTitleContainer, 'd-flex justify-content-between')}
          style={{ alignItems: 'center', cursor: 'pointer', paddingBottom: '3px' }}
          onClick={() => setOpen((o) => !o)}
        >
          <span className={classNames(styles.dividerTextLarge)} style={{ flex: 1 }}>JOB POST BRANDING</span>
          <span className={classNames(styles.dividerTextLarge)}>
            <Badge className={classNames('premiumPill d-flex', styles.jobPremiumPill)}>
              PREMIUM JOBS ONLY
            </Badge>
          </span>
          <span
            style={{
              fontSize: 32,
              userSelect: 'none',
              transition: 'transform 0.2s',
              transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
              color: '#9a9a9a',
              display: 'flex',
              alignItems: 'center',
              marginTop: '-4px'
            }}
          >
            ⌄
          </span>
        </div>
        <div className={classNames(styles.compCardContent)} style={{ display: open ? 'block' : 'none' }}>
          <div className="w-100">
            <JobImageLogoDescription logo={state.logo} hideUploadButton={true}/>
            <ImageUpload
              state={state}
              setState={setState}
              name="job_images"
              label="Upload photos of your post"
              description="Upload and select which photos to display in your post. Jpg, Png, or Gif file types only."
            >
              <Button submit inline size="small">
                Upload photo
              </Button>
            </ImageUpload>
          </div>
        </div>
      </div>
    </>
  );
};
